<template>
  <div class="wrap-data-list">
    <p class="title-data-list">Experience Manager</p>

    <!-- Tab -->
    <div class="tabs">
      <div
        v-for="tab in tabs"
        :key="tab.id"
        :class="{ 'tab-active': tab.id === tabSelected }"
        class="tab"
        @click="tabSelected = tab.id"
      >
        {{ tab.text }}
      </div>
    </div>

    <!-- Loading -->
    <j-loading-trigger-list v-if="isLoading" />

    <div
      v-if="!isLoading"
      class="exp-manager"
    >
      <!-- Data list -->
      <template v-if="datas.length > 0">
        <div
          v-for="data in datas"
          :key="data.id"
          class="data-list"
        >
          <div class="section-left">
            <img
              :alt="`icon-list-${data.id}`"
              src="@/assets/icon-sidebar/experience-manager.svg"
              width="20"
              height="20"
            >
            <div class="exp-id">{{ data.id }}</div>
            <div class="wrap-exp-type">
              <div class="exp-type">{{ tabSelected }}</div>
            </div>
            <p class="exp-name">{{ data.name }}</p>
          </div>

          <div class="section-right">
            <div class="lines" />
            <div class="d-flex align-items-center">
              <div class="wrap-btn-action mr-2">
                <div class="info-icon">
                  <i
                    class="fa fa-info"
                    style="cursor: default;"
                  />
                </div>
                <div class="tooltip-component">
                  <div class="wrap-timestamp">
                    <div class="timestamp-type">
                      <p>Created</p>
                      <p>Updated</p>
                    </div>
                    <div class="timestamp">
                      <p>{{ formatFullDateTime(data.created_at) }}</p>
                      <p>{{ formatFullDateTime(data.updated_at) }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wrap-btn-action mr-2">
                <i
                  class="fa fa-external-link"
                  style="margin-top: 6px;"
                  @click="onOpenNewTab(data)"
                />
                <div class="tooltip-component">Open new tab</div>
              </div>
              <div class="wrap-btn-action">
                <i
                  class="fa fa-trash"
                  @click="onDeleteExpManager(data)"
                />
                <div class="tooltip-component">Delete experience manager</div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- If data is empty -->
      <p
        v-if="datas.length === 0"
        class="data-not-found"
      >
        {{
          isHaveData ?
            'All data has been displayed' :
            `No ${tabSelected} experience manager registered`
        }}
      </p>

      <!-- Pagination -->
      <div
        v-if="isHaveData"
        class="custom-pagination"
      >
        <div
          :style="[page === 1 ?
            {'opacity': '0.5', 'cursor': 'not-allowed'} :
          '']"
          class="btn-previous"
          @click="previousPage"
        >
          <i class="fa fa-chevron-left"/>
        </div>
        <div
          :style="[datas.length < 100 ?
            {'opacity': '0.5', 'cursor': 'not-allowed'} :
          '']"
          class="btn-forward"
          @click="nextPage"
        >
          <i class="fa fa-chevron-right"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-plusplus */
import jwtDecode from 'jwt-decode';
import { mapActions, mapState } from 'vuex';
// Services
import jApiFormUi from '@/services/jApiFormUi';
// Components
import jLoadingTriggerList from '@/components/skeleton-loading/jLoadingTriggerList';

export default {
  components: {
    jLoadingTriggerList,
  },

  data() {
    return {
      isLoading: true,
      isHaveData: false,
      datas: [],
      tabs: [
        { id: 'single', text: 'SINGLE' },
        { id: 'multiple', text: 'MULTIPLE' },
      ],
      tabSelected: 'single',
      page: 1,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    ...mapState('jStoreJoana', ['dataset_data']),
  },

  watch: {
    tabSelected() {
      this.page = 1;
      this.getDataList();
    },
  },


  created() {
    this.getDataList();
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading', 'toggleSuccess']),

    async getDataList() {
      this.isLoading = true;
      const payload = {
        page: this.page,
        limit: 100,
        sort: { updated_at: -1 },
        filter: {
          company_id: this.session.user.company_id,
          'data_source.dataset.dataset_id': this.dataset_data.id,
        },
      };

      const service = this.tabSelected === 'single' ? jApiFormUi.getSetupFormUi : jApiFormUi.getSetupMultiFormUi;
      const res = await service(payload);
      if (!res.error) {
        this.datas = res.data;
        if (this.page === 1) this.isHaveData = res.data.length > 0;
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 300);
    },

    onOpenNewTab(data) {
      const type = this.tabSelected === 'single' ? 'experience-manager' : 'multiple-experience-manager';
      const url = `${window.location.origin}/#/${type}/update/${data.id}`;
      window.open(url, '_blank');
    },

    onDeleteExpManager(data) {
      const text = 'Are you sure to delete this experience manager?';

      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const service = this.tabSelected === 'single' ? jApiFormUi.deleteForm : jApiFormUi.deleteMultiForm;
          const payload = { id: data.id };
          this.showLoading();
          const res = await service(payload);
          if (res) {
            this.hideLoading();
            if (!res.error) {
              this.page = 1;
              this.toggleSuccess(res.message);
              this.getDataList();
            } else {
              this.toggleProblem(res.message);
            }
          }
        }
      });
    },

    previousPage() {
      if (this.page > 1) {
        this.page = this.page - 1;
        this.getDataList();
      }
    },

    nextPage() {
      if (this.masterTriggers.length === 100) {
        this.page = this.page + 1;
        this.getDataList();
      }
    },

    formatFullDateTime(timestamp) {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const date = new Date(timestamp);
      const day = String(date.getDate()).padStart(2, '0');
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      return `${day} ${month} ${year} ${hours}:${minutes}:${second}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin font($family, $size, $color) {
  font-family: $family;
  font-size: $size;
  color: $color;
}

.wrap-data-list {
  padding: 40px 60px;

  .title-data-list {
    @include font('Poppins-Semibold', 16px, $black-2);
    margin-bottom: 18px;
  }
  .tabs {
    display: flex;
    margin-bottom: 12px;

    .tab {
      @include font('Poppins-Semibold', 14px, $gray-1);
      padding-bottom: 2px;
      border-bottom: 4px solid transparent;
      margin-right: 8px;
      cursor: pointer;

      &.tab-active {
        color: #5B5A5A;
        border-color: $primary;
      }
    }
  }
  .exp-manager {
    .data-list {
      width: 100%;
      height: auto;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid $gray-border;
      border-radius: 8px;
      padding: 12px 14px;
      margin-bottom: 15px;

      .section-left {
        display: flex;
        align-items: center;

        img {
          margin-right: 6px;
        }
        .exp-id {
          width: 90px;
          @include font('Poppins-Semibold', 12px, #BDBDBD);
          border-right: 1px solid $gray-border;
          margin-right: 12px;
          padding-right: 12px;
          white-space: nowrap;
        }
        .wrap-exp-type {
          margin-right: 12px;
          padding-right: 12px;
          border-right: 1px solid $gray-border;

          .exp-type {
            width: min-content;
            @include font('Poppins-Semibold', 12px, #808285);
            padding: 0 5px;
            border: 1px solid #808285;
            border-radius: 6px;
            text-transform: uppercase;
            white-space: nowrap;
          }
        }
        .exp-name {
          @include font('Poppins-Regular', 14px, #525252);
          margin-bottom: 0;
        }
      }

      .section-right {
        display: flex;
        align-items: center;

        .lines {
          width: 1px;
          height: 18px;
          background-color: $gray-border;
          margin: 0 12px;
        }
        .wrap-btn-action {
          position: relative;

          .info-icon {
            width: 16px;
            height: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 9999px;
            border: 1px solid $black-2;

            i {
              font-size: 10px;
              margin-right: 1px;
            }
          }
          i {
            font-size: 16px;
            color: $black-2;
            cursor: pointer;
          }
          .tooltip-component {
            position: absolute;
            top: 25px;
            right: 0;
            display: none;
            background-color: white;
            padding: 6px;
            border-radius: 10px;
            box-shadow: 0px 1px 12px rgba(114, 109, 109, 0.25);
            font-family: 'Poppins-Medium';
            font-size: 12px;
            color: #606060;
            white-space: nowrap;
            transition: display ease 0.4s;
            z-index: 1;

            .wrap-timestamp {
              display: grid;
              grid-template-columns: min-content 1fr;
              grid-gap: 4px;

              .timestamp-type {
                p {
                  @include font('Poppins-Semibold', 12px, $gray-1);
                  margin-bottom: 2px;

                  &:last-child {
                    margin-bottom: 0
                  }
                }
              }
              .timestamp {
                p {
                  @include font('Poppins-Regular', 12px, $gray-1);
                  text-align: right;
                  white-space: nowrap;
                  margin-bottom: 2px;

                  &:last-child {
                    margin-bottom: 0
                  }
                }
              }
            }
          }
          &:hover {
            .tooltip-component {
              display: block;
            }
          }
        }
      }
    }

    .data-not-found {
      @include font('Poppins-Semibold', 14px, $black);
      margin-top: 20px;
      margin-bottom: 0;
    }
  }
}

@media screen and (max-width: 1400px) {
  .wrap-data-list {
    padding: 40px 20px;
  }
}

@media screen and (max-width: 1280px) {
  .wrap-data-list {
    .exp-manager {
      .data-list {
        .section-left {
          .exp-name {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/jDatasetExpManager.vue